import { Link } from 'react-router-dom';
import { trpc } from '../lib/trpc';
import { useAuth } from '../hooks/useAuth';
import { BookmarkIcon } from './ui/icons/BookmarkIcon';

interface WishlistMatchBadgeProps {
  venueId: string;
}

export const WishlistMatchBadge = ({ venueId }: WishlistMatchBadgeProps) => {
  const { user } = useAuth();
  const query = trpc.user.wishlistMatchForVenue.useQuery(
    { venueId },
    { enabled: Boolean(user && venueId) }
  );

  if (!user || !query.data || query.data.count === 0) return null;

  const { count } = query.data;
  return (
    <Link
      to={`/wineries/${venueId}/wines?filter=wishlist`}
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-50 text-primary-800 border border-primary-200 hover:bg-primary-100 text-sm font-sans"
      aria-live="polite"
    >
      <BookmarkIcon className="h-4 w-4" filled />
      {count === 1
        ? '1 of your wishlist wines is poured here'
        : `${count} of your wishlist wines are poured here`}
    </Link>
  );
};
